<loader-page [show]="carregando"></loader-page>

<table-list
    #listagemEmails
    [resource]="emailsResource"
    [service]="adminEmailsService"
    [filterConfiguration]="filterConfiguration"
    [actionsIncrement]="actions"
></table-list>
